module.exports = __webpack_public_path__ + "img/Manuel-10.61a8c1b6.jpg";